import { HeaderService } from "@app/components/header/header.service";
import { PaymentRequest } from "@app/models/PaymentRequest";
import { Homeowner } from "@app/models/Homeowner";
import { GuestPaymentStore } from "@app/services/stores/GuestPaymentStore";
import { PrintService } from "@app/services/Print.service";
import { Component, Inject, OnInit } from "@angular/core";
import { WindowToken } from "@app/util/window.token";
import { AppDataService } from "@app/services/appData.service";
import { Router } from "@angular/router";

export type $stateParams = {
    paymentConfirmationNumber: string // "123",
    paymentId: string // "1"
    homeowner: Homeowner
    paymentRequest: PaymentRequest
}
@Component({
    selector: 'app-guest-payment-cancel',
    template: require('./guestPaymentCancel.html')
})

export class GuestPaymentCancelComponent implements OnInit {
    paymentRequest: PaymentRequest;
    homeowner: Homeowner;
    paymentConfirmationNumber: any;
    paymentId: string;
    $stateParams: $stateParams;

    constructor(
        @Inject(WindowToken) public window,
        @Inject(AppDataService) private appDataService: AppDataService,
        @Inject(PrintService) private printService: PrintService,
        @Inject(HeaderService) private headerService: HeaderService,
        @Inject(GuestPaymentStore) private guestPaymentStore: GuestPaymentStore,
        @Inject(Router) private router: Router) {

        if(this.router.getCurrentNavigation()) {
            this.$stateParams = this.router.getCurrentNavigation().extras.state as $stateParams
        }

    }

    ngOnInit() {
        this.headerService.setDisplayRightContent(false);
        if (this.$stateParams
            && this.$stateParams.paymentConfirmationNumber
            && this.$stateParams.paymentId
            && this.$stateParams.homeowner
            && this.$stateParams.paymentRequest
        ) {
            this.paymentRequest = this.guestPaymentStore.getPaymentRequest();
            this.paymentConfirmationNumber = this.$stateParams.paymentConfirmationNumber;
            this.paymentId = this.$stateParams.paymentId;
            this.homeowner = this.$stateParams.homeowner;
            this.paymentRequest = this.$stateParams.paymentRequest;
        } else {
            const webUrl = this.appDataService.appConfig.get_APP_ENV().HOAPASS_WEB_URL;
            const propertyUrlData = webUrl + "/guest/#/guestpayment";
            this.window.location.replace(propertyUrlData);
        }
    }

    goToWelcomePage() {
        this.guestPaymentStore.clearAllGuest();
        this.window.location.replace("/");
    }

    clickPrint() {
        this.printService.print("Cancelled Payment", "Clicked print button")
    }
}
